export enum ActiveTokensEnum {
    'DAI' = 'dai',
}

export const ACTIVE_TOKENS: ActiveTokensEnum[] = [ActiveTokensEnum.DAI];
